module.exports = __webpack_public_path__ + "img/image.3457e2e9.svg";